import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

/**
 * The standard «Настройки» page is replaced by ours. Settings that OTHER extensions add to it
 * are not lost: this renders whatever is left in core SettingsPage's lists after removing
 * the parts that already live elsewhere (tabs «Главная» / «Оповещения», «Цветовая схема»,
 * «Безопасность и удаление»). Those items keep their own behaviour (usually saved at once).
 */
const KNOWN = {
  settingsItems: ['account', 'notifications', 'privacy', 'device', 'colorScheme', 'dataItems'],
  // flarum/nicknames «Изменить псевдоним» (changeNickname) is intentionally dropped
  accountItems: ['changePassword', 'changeEmail', 'changeNickname'],
  notificationsItems: ['notificationGrid', 'resetNotifications', 'followAfterReply', 'followAfterCreate', 'notifyForAllPosts'],
  privacyItems: ['discloseOnline'],
  deviceItems: ['hapticFeedback']
};
const loaded = {
  proto: null,
  loading: false,
  failed: false
};
function load() {
  if (loaded.proto || loaded.loading || loaded.failed) return;
  loaded.loading = true;
  flarum.reg.asyncModuleImport('flarum/forum/components/SettingsPage').then(mod => {
    loaded.proto = (mod.default || mod).prototype;
  }).catch(() => loaded.failed = true).finally(() => {
    loaded.loading = false;
    m.redraw();
  });
}

/** [key, vnode] of every unknown item; new vnodes each call (Mithril must not reuse them). */
export function otherSettingsItems(user) {
  load();
  if (!loaded.proto || !user) return [];
  const page = Object.create(loaded.proto);
  page.user = user;
  page.attrs = {};
  const out = [];
  try {
    const lists = ['accountItems', 'notificationsItems', 'privacyItems', 'deviceItems'];
    lists.forEach(list => {
      if (typeof page[list] !== 'function') return;
      const items = page[list]();
      Object.keys(items.toObject()).forEach(key => {
        if (!KNOWN[list].includes(key)) out.push([list + '.' + key, items.get(key)]);
      });
    });
    const top = page.settingsItems();
    Object.keys(top.toObject()).forEach(key => {
      if (!KNOWN.settingsItems.includes(key)) out.push(['settingsItems.' + key, top.get(key)]);
    });
  } catch (e) {
    // a foreign item that cannot run outside its page is skipped
    console.warn('[ppk2-profile] other settings:', e);
  }
  return out;
}
export default class OtherSettings extends Component {
  view() {
    const items = otherSettingsItems(this.attrs.user);
    if (!items.length) return null;
    return m("div", {
      className: "Ppk2OtherSettings"
    }, this.attrs.heading, m("ul", {
      className: "Ppk2OtherSettings-list"
    }, items.map(([key, vnode]) => m("li", {
      key: key,
      className: 'Ppk2OtherSettings-item item-' + key.replace('.', '-')
    }, vnode))));
  }
}
flarum.reg.add('ppk2-profile', 'forum/components/OtherSettings', OtherSettings);